import { CSSObject } from "@emotion/react";
import { constants } from "@newsela/angelou";

const { ui } = constants.colors;

export const actionButtonsCss: CSSObject = {
  display: "flex",
  flexFlow: "row wrap",
  justifyContent: "space-between",
  gap: "8px",
  marginTop: "1em",
  marginBottom: "1em",
  color: ui.neutral[500],
  "> div": {
    textAlign: "right",
  },
};

export const algorithmOutputCss: CSSObject = {
  whiteSpace: "pre-wrap",
  padding: "1em",
  margin: "0 1rem 1rem",
  border: `1px solid ${ui.neutral[100]}`,
  borderRadius: "4px",
  background: ui.white[500],
};

export const bodyPaddingCss: CSSObject = {
  padding: "0 1em 1em",
};

export const disclaimerCss: CSSObject = {
  color: ui.neutral[500],
  marginTop: "1em",
  fontStyle: "italic",
};
